import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { RequestFeedbackData } from "../types";
import { ErrorOutline } from "@mui/icons-material";

type SummaryItemProps = {
  label: string;
  value: string;
};

const SummaryItem: FC<SummaryItemProps> = ({ label, value }) => {
  return (
    <Stack direction="row" justifyContent="space-between" sx={{ my: 0.5 }}>
      <Typography variant="body1" fontWeight="bold" minWidth={210}>
        {label}
      </Typography>
      {value ? (
        <Typography variant="body1" textAlign="right">
          {value}
        </Typography>
      ) : (
        <Typography variant="body1" textAlign="right" color="textDisabled">
          <ErrorOutline sx={{ fontSize: 16 }} /> Missing
        </Typography>
      )}
    </Stack>
  );
};

type SummaryBoxProps = {
  data: RequestFeedbackData;
};

export const SummaryBox: FC<SummaryBoxProps> = ({ data }) => {
  return (
    <Box>
      <SummaryItem label="Observation Date" value={data.observationDate} />
      {data.coachAvailable ? (
        <SummaryItem label="Feedback Type" value={"IN-PERSON"} />
      ) : (
        <SummaryItem label="Feedback Type" value={"ONLINE"} />
      )}
      <SummaryItem label="Pet Name" value={data.name ?? ""} />
      <SummaryItem label="Additional information" value={data.mrn} />
      <SummaryItem
        label="Animal Patient Species"
        value={data.selectedSpecies?.name ?? ""}
      />
      <SummaryItem label="Animal Patient Sex" value={data.animalSex} />
      <SummaryItem label="Site" value={data.selectedSite?.name ?? "N/A"} />
      <SummaryItem label="Course or Specialty" value={data.course} />

      <SummaryItem
        label="Selected Coach"
        value={data.selectedCoach?.name ?? ""}
      />
      {data.selectedLearner && (
        <SummaryItem
          label="Selected Learner"
          value={data.selectedLearner?.name ?? ""}
        />
      )}

      <SummaryItem
        label="Observed Skill"
        value={data.selectedCompetencySkill?.name ?? ""}
      />
    </Box>
  );
};
